import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export const SerialCodeInputModal = universal(
    universalImport({
        chunkName: () => 'CartPageModalsLazy',
        path: () =>
            path.join(
                __dirname,
                'yoda-checkout-components/lib/components/Coupons/SerialCodeInputModal/SerialCodeInputModal'
            ),
        resolve: () =>
            require.resolveWeak(
                'yoda-checkout-components/lib/components/Coupons/SerialCodeInputModal/SerialCodeInputModal'
            ),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "CartPageModalsLazy" */ 'yoda-checkout-components/lib/components/Coupons/SerialCodeInputModal/SerialCodeInputModal'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);

/* istanbul ignore next */
export const CouponsPanel = universal(
    universalImport({
        chunkName: () => 'CartPageModalsLazy',
        path: () =>
            path.join(__dirname, 'yoda-checkout-components/lib/components/Coupons/CouponsPanel'),
        resolve: () =>
            require.resolveWeak('yoda-checkout-components/lib/components/Coupons/CouponsPanel'),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "CartPageModalsLazy" */ 'yoda-checkout-components/lib/components/Coupons/CouponsPanel'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);

/* istanbul ignore next */
export const ShowRewardsPanel = universal(
    universalImport({
        chunkName: () => 'CartPageModalsLazy',
        path: () =>
            path.join(
                __dirname,
                'yoda-checkout-components/lib/components/ShowRewardsPanel/ShowRewardsPanel'
            ),
        resolve: () =>
            require.resolveWeak(
                'yoda-checkout-components/lib/components/ShowRewardsPanel/ShowRewardsPanel'
            ),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "CartPageModalsLazy" */ 'yoda-checkout-components/lib/components/ShowRewardsPanel/ShowRewardsPanel'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);

/* istanbul ignore next */
export const SessionTimeoutModal = universal(
    universalImport({
        chunkName: () => 'CartPageModalsLazy',
        path: () =>
            path.join(
                __dirname,
                'yoda-checkout-components/lib/components/SessionTimeoutModal/SessionTimeoutModal'
            ),
        resolve: () =>
            require.resolveWeak(
                'yoda-checkout-components/lib/components/SessionTimeoutModal/SessionTimeoutModal'
            ),
        load: () =>
            Promise.all([
                import(
                    /* webpackChunkName: "CartPageModalsLazy" */ 'yoda-checkout-components/lib/components/SessionTimeoutModal/SessionTimeoutModal'
                ),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
    }
);
